module.exports = __webpack_public_path__ + "img/logo-mobile.671e84c4.png";